import { useSelectedLocation } from "components";
import { useTypedQuery } from "hooks";
import { ShareboxDashboardQueryKeys } from "modules/ShareboxDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

export const useShareboxLogsQuery = (page: number) => {
  const { selectedLocation } = useSelectedLocation();

  const { data, isFetching } = useTypedQuery({
    queryKey: ShareboxDashboardQueryKeys.list,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { dealer_location_id: selectedLocation?.id, page }, baseUrl)).data,
    enabled: Boolean(selectedLocation?.id),
    refetchOnDependencies: [selectedLocation?.id, page]
  });

  return { shareboxLogs: data?.items || [], nbPages: data?.nb_pages || 0, isFetching };
};
